import alertClose from './alertClose'

export const alertClosePromise = alertClose
